<template>
    <el-container>
      <el-col :span="24" v-if="authorzationshow"  style="margin-top: 12%; text-align: center;">
        <el-button type="success" size="medium" @click="registerboxshow = true"><i class="fa fa-user"></i>一键生成支付系统</el-button>
        <span style="font-size: 8px; display: block;">已经存在用户，<el-button @click="exitesShow = true" type="text" style="color: red;">点击此处</el-button>快速绑定</span>
      </el-col>
      <el-row :span="24" v-if="paymentshow">
        <div class="toolbar">
        <el-form :model="searchData" name="toolsearch" ref="toolsearch" :inline="true">
          <el-form-item label="支付名称" prop="Name">
            <el-input v-model="searchData.Name" placeholder="请输入支付方式名称"></el-input>
          </el-form-item>
          <el-form-item label="支付通道" prop="payment__name">
            <el-input v-model="searchData.payment__name" placeholder="请输入支付通道名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button-group>
              <el-button type="success"><i class="fa fa-search"></i>搜索</el-button>
              <el-button type="success" @click="rsashow  = true"><i class="fa fa-key"></i>支付密钥对</el-button>
              <el-button type="success" @click="confirmPaypalExpress"><i class="fa fa-paypal"></i>启用paypal快速支付</el-button>
            </el-button-group>
          </el-form-item>
        </el-form>
      </div>
        <el-row style="display: flex; justify-content: flex-start; align-items: stretch; flex-wrap: wrap; padding: 22px;">
          <el-col :span="3" v-for="way in gatewaypage" :key="way.ID" class="commonhover" style="display: flex; justify-content: center; align-items: baseline; flex-wrap: wrap;">
            <el-tooltip class="item" effect="dark" placement="top">
              <template slot="content">
                <div style="width: 250px; line-height: 23px;">
                  <span>{{ way.desc }}</span>
                  <p><b>官方网站：</b>{{ way.officeweb }}</p>
               </div>
              </template>
              <div v-if="way.imagecover">
                <div class="cover" style="height: 80px; display: flex; justify-content: center; align-items: center;"><img :src="way.imagecover" style="width: 40%; object-fit: cover;"/></div>
                <div style="text-align: center;">{{ way.name }}</div>
              </div>
              <div v-else class="commonhover">
                <h2>{{ way.name }}</h2>
              </div>
            </el-tooltip>
            <el-button type="text" style="color: black;" @click="makeactive(way)">
              <div v-if="way.status">可使用</div>
              <div v-else>内测中</div>
              <el-col :span="24" style="display: block; text-align: center; margin-top: 16px;"><el-switch v-model="way.isactive" active-color="#13ce66" inactive-color="#ff4949" :active-value="true"></el-switch></el-col>
            </el-button>
          </el-col>
        </el-row>
         <el-row style="margin-top: 42px;">
          <el-pagination
            @current-change="paymentPage"
            :current-page="loadGateways"
            :page-sizes="[20]"
            :page-size="20"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paymentPage.total">
          </el-pagination>
        </el-row>
      </el-row>
      <el-dialog :visible.sync="registerboxshow">
          <el-form :model="regData" name="regForm" ref="regForm">
            <el-form-item label="用户名" prop="UserName" required>
              <el-input v-model="regData.UserName"  placeholder="请输入用户名"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="PassWord" required>
              <el-input v-model="regData.PassWord" type="password" placeholder="请输入用户密码"></el-input>
            </el-form-item>
            <el-form-item label="名" prop="FirstName" required>
              <el-input v-model="regData.FirstName" placeholder="请输入您的名字"></el-input>
            </el-form-item>
            <el-form-item label="姓" prop="LastName" required>
              <el-input v-model="regData.LastName" placeholder="请输入您的姓氏"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="Telephone" required>
              <el-input v-model="regData.Telephone" placeholder="请输入您的联系电话"></el-input>
            </el-form-item>
            <el-form-item label="邮箱地址" prop="Email" required>
              <el-input v-model="regData.Email" placeholder="请输入您的邮箱地址"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="corpName" required>
              <el-input v-model="regData.corpName" placeholder="请输入您的公司名称"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="contractAddress" required>
              <el-input v-model="regData.contractAddress" placeholder="请输入您的联系地址"></el-input>
            </el-form-item>
            <el-form-item style="text-align: right">
              <el-button type="success" @click="handlePayment('regForm')"><i class="fa fa-user"></i>申请帐户</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      <el-dialog :visible.sync="rsashow">
        <el-form :model="rsaData">
          <el-form-item label="私钥">
            <el-input type="textarea" rows="6" v-model="rsaData.privateRsa"></el-input>
          </el-form-item>
          <el-form-item label="公钥">
            <el-input type="textarea" rows="4" v-model="rsaData.publicRsa"></el-input>
          </el-form-item>
        </el-form>
      </el-dialog>
      <el-dialog :visible.sync="votebox">
        <el-form :model="voteData" name="newPaymentForm" ref="newPaymentForm">
          <el-form-item v-for="field in crrActivePayment.fields" :key="field.ID" :label="field.Name" :prop="field.orginField" required="">
            <el-input v-model="voteData[field.orginField]" :placeholder="field.placeOrder"></el-input>
          </el-form-item>
        </el-form>
        <el-form>
          <el-form-item label="Gateway">
            <el-input v-model="crrActivePayment.gateway" :disabled="true"></el-input>
          </el-form-item>
          <el-form-item label="回调地址">
            <el-input v-model="crrActivePayment.callback" :disabled="true"></el-input>
          </el-form-item>
        </el-form>
        <div style="text-align: right"><el-button type="success" @click="applyNewPayment('newPaymentForm')"><i class="fa fa-yen"></i>提交新的支付通道</el-button></div>
      </el-dialog>
      <el-dialog :visible.sync="exitesShow">
        <h3 slot="title">使用现有支付帐户绑定</h3>
        <el-form :model="exites" ref="exitesForm" size="small">
          <el-form-item label="开发者KEY" prop="key" required>
            <el-input v-model="exites.key" placeholder="请输入开发者key"/>
          </el-form-item>
          <el-form-item label="开发者SECRET" prop="secret" required>
            <el-input v-model="exites.secret" placeholder="请输入开发者secret"/>
          </el-form-item>
        </el-form>
        <div style="text-align: right" slot="footer">
          <el-button type="primary" @click="handleExites('exitesForm')">连接已有支付帐户</el-button>
        </div>
      </el-dialog>
    </el-container>
</template>

<script>
export default {
  name: 'Payments',
  data () {
    return {
      searchData: {},
      authorzationshow: false,
      paymentshow: false,
      registerboxshow: false,
      regData: {},
      gatewaypage: [],
      paymentPage: {page: 1, 'total': 0},
      rsaData: {},
      rsashow: false,
      crrActivePayment: {},
      voteData: {},
      votebox: false,
      load: '',
      exitesShow: false,
      exites: {}
    }
  },
  beforeCreate () {
    var that = this
    var para = {}
    para.method = 'base.haspaymentauthorization'
    that.$http.post(that.$apiurl, para).then(function (ret) {
      console.log(ret.body.data.code)
      if (ret.body.data.code === 200) {
        that.paymentshow = true
      } else {
        that.authorzationshow = true
      }
    })
  },
  mounted () {
    this.loadGateways(1)
    this.loadPayAccount()
  },
  methods: {
    /**
     * 配置paypal快捷支付
     */
    confirmPaypalExpress: function () {
      var that = this
      var paypal
      for (var i = 0; i < that.gatewaypage.length; i++) {
        if (that.gatewaypage[i].code === 'paypal') {
          paypal = that.gatewaypage[i]
          break
        }
      }
      if (paypal.isactive) {
        var para = {}
        para.clientId = JSON.parse(paypal.userconfig.authField).clientid
        para.method = 'shop.updatePaypalExpress'
        that.fullLoad()
        that.$http.post(that.$apiurl, para).then(function (ret) {
          that.hasloaded()
          if (ret.data.code === 200) {
            that.$message.success('paypal快捷支付关联成功')
          } else {
            that.$alert('paypal快捷支付关联错误,请检查后重试')
          }
        })
      } else {
        that.$alert('请先行激活paypal支付')
      }
    },
    /**
     * 已存在帐户
     * @param formName
     */
    handleExites: function (formName) {
      var that = this
      that.$refs[formName].validate(function (valid) {
        if (valid) {
          var para = that.exites
          para.method = 'shop.addexitespayment'
          that.fullLoad()
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.data.code === 200) {
              that.$message.success('支付方式初始化成功')
              that.authorzationshow = false
              that.paymentshow = true
            } else {
              that.$alert('用户已经存在或则其他错误错误,请检查后重试')
            }
          })
        }
      })
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    handlePayment: function (formname) {
      console.log(formname)
      var that = this
      this.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.regData
          para.method = 'base.createsettlementacount'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            if (ret.data.code === 200) {
              that.$message.success('支付方式初始化成功')
              that.authorzationshow = false
              that.paymentshow = true
            } else {
              that.$alert('用户已经存在或则其他错误错误,请检查后重试')
            }
          })
        }
      })
    },
    loadGateways: function (page) {
      var that = this
      var para = {}
      para.method = 'base.paymentgateways'
      para.page = page
      para.num = 42
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.gatewaypage = ret.body.data.data
        that.paymentPage.total = ret.body.data.count
      })
    },
    loadPayAccount: function () {
      var that = this
      var para = {}
      para.method = 'base.payaccount'
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.rsaData = ret.body.data
      })
    },
    makeactive: function (data) {
      console.log(data)
      if (data.status) {
        var that = this
        this.crrActivePayment = data
        var fields = data.fields
        if (fields.length === 0) {
          var para = {}
          para.pid = data.ID
          that.handleNewPayment(para)
        } else {
          this.votebox = true
        }
      } else {
        this.$message.error('此支付方式正在内测中，请联系管理员参与内测或则提前使用')
      }
    },
    handleNewPayment: function (data) {
      var that = this
      var para = data
      para.method = 'base.addpayment'
      that.fullLoad()
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.hasloaded()
        if (ret.body.data.code === 200) {
          if (ret.body.data.url) {
            window.open(ret.body.data.url, '_blank')
            that.fullLoad()
            var task = setInterval(function () {
              var tdd = {}
              tdd.pid = data.pid
              tdd.method = 'base.paymentstate'
              that.$http.post(that.$apiurl, tdd).then(function (ret) {
                if (ret.body.data.code === 200) {
                  that.$message.success('支付授权成功!')
                  clearInterval(task)
                  that.hasloaded()
                }
              })
            }, 5000)
            setTimeout(function () {
              that.$message.error('超时未完成支付授权，请下次再试！')
              that.hasloaded()
            }, 120000)
          } else {
            that.$message.success('支付授权成功!')
          }
        } else {
          that.$alert('新增授权失败，请稍后重试!')
        }
      })
    },
    applyNewPayment: function (formname) {
      var that = this
      that.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.voteData
          para.pid = that.crrActivePayment.ID
          that.handleNewPayment(para)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/merchant/Payments.vue